import * as React from 'react';
import { useHistory } from 'react-router-dom';

import { Alert, Typography } from 'antd';

import Modal from 'v2/components/Shared/Modal';
import { BankAccountDisappovalReasonId } from 'v2/interfaces/financial';

import { stepsReasonsId } from './constants';
import type { CancelReasonModalProps } from './constants';

function CancelReasonModal({ isOpen, setClose, reason }: CancelReasonModalProps) {
  const history = useHistory();

  const messageDefault = 'Não foi informado o motivo de cancelamento. Entre em contato com o time de atendimento.';

  const getErrorStep = (errorId: number) => {
    const { second, third } = stepsReasonsId;

    if (second.includes(errorId)) return '2';
    if (third.includes(errorId)) return '3';
    return '1';
  };

  const handleGoToEditStep = () => {
    sessionStorage.setItem('step_error', getErrorStep(reason.id));

    history.push('/producer/profile/add-bank-account', {
      bankAccountId: reason.bankAccountId,
      description: reason.description || messageDefault,
      step: parseInt(getErrorStep(reason.id))
    });
  };

  const cancelledByOwnership = reason?.id === BankAccountDisappovalReasonId.CHANGE_OWNERSHIP;

  return (
    <Modal
      size='xs'
      open={isOpen}
      textTitle='Motivo'
      textReturnButton={cancelledByOwnership ? 'Fechar' : 'Cancelar'}
      textProceedButton='Editar'
      setClose={setClose}
      handleProceedClick={handleGoToEditStep}
      hideProceedButton={cancelledByOwnership}
    >
      {reason?.description ? (
        <Typography.Paragraph className='mb-0'>{reason.description}</Typography.Paragraph>
      ) : (
        <Alert type='warning' showIcon message={messageDefault} />
      )}
    </Modal>
  );
}

export { CancelReasonModal };
